var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-stage',{attrs:{"id":"mapstage","config":_vm.konva_stage}},[_c('v-layer',[_c('v-image',{attrs:{"config":_vm.image_object}}),_c('v-line',{attrs:{"config":_vm.vLine}}),_c('v-image',{attrs:{"config":_vm.bs_image_object}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }